import React from "react";
import { Container, Grid } from "@mui/material";

import { useTranslation } from "react-i18next";

import BackgroundImage from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import Breadcrumb from "@components/Breadcrumb";
import CardHomeCst from "@components/CardHomeCst";
import { useMenu, useNavigaionRoutes } from "@hooks/useNavigation";
import { useAuth } from "@context/auth";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useResetFilters } from "@hooks/useFiltersProvider";

const Skills: React.FC = () => {
  // const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation(["skills-page", "common"]);

  const menuItem = useMenu();
  const navigation = useNavigaionRoutes();

  const skillsSection = [
    "skills.profession.retrieve",
    "skills.knowledge.area.retrieve",
    "skills.capabilities.retrieve",
    "skills.job.knowledge.suggestion.read",
    "skills.levels.retrieve",
  ];

  useResetFilters();

  let skillsMenu = [];
  if (menuItem.length > 0) {
    skillsMenu = navigation
      .find((el) => el.to === "skills")
      ?.children?.filter((el: { section: string }) => {
        return (
          user?.permissions?.includes(el.section) &&
          skillsSection?.includes(el.section)
        );
      });
  }

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-skills.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("hero-title")} description={t("hero-description")} />
        <Grid container spacing={3}>
          {skillsMenu.map((card: any, index: number) => (
            <Grid key={index} item xs={12} md={6} xl={4}>
              <CardHomeCst
                image={card.image}
                title={card.text}
                to={card.to}
                description={card.description}
                secondaryBtnLabel={card.buttonLabel}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </AnimationFadeIn>
  );
};

export default Skills;
